<script setup lang="ts"></script>

<template>
  <div class="docs-page">
    <div class="docs-header__container container container-main py-2 md:py-[16px] bg-white z-10">
      <div class="flex items-center flex-col">
        <div class="flex w-full items-center xl:gap-[100px]">
          <router-link :to="{ name: '/home' }" class="mx-auto xl:mr-0 xl:mx-0 xl:shrink-0 max-[1280px]:ml-0">
            <figure class="docs-header__logo">
              <img
                loading="lazy"
                src="/svg/logo.svg"
                alt="AfterSchoolVote"
                class="docs-header__logo-img"
              />
            </figure>
          </router-link>
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
.docs-page {
  min-height: 100vh;
  background: #ffffff;
}

.docs-header {
  &__container {
    background-image: url("/img/docs/container-bg.png");
    background-repeat: no-repeat;
    background-size: 80%;
    background-position: top center;
    @include xl() {
      background: transparent;
    }
  }

  &__logo {
    display: flex;
    align-items: center;
    height: 40px;
    margin: 0;
  }

  &__logo-img {
    display: block;
    height: 40px;
    width: auto;

    @include xl() {
      height: 55px;
    }
  }
}
</style>
